import { render, staticRenderFns } from "./varietyBalanceReport.vue?vue&type=template&id=676cb996&"
import script from "./varietyBalanceReport.vue?vue&type=script&lang=js&"
export * from "./varietyBalanceReport.vue?vue&type=script&lang=js&"
import style0 from "./varietyBalanceReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports